<template>
  <div class="flex flex-col items-center w-full">
    <div
      class="relative w-full max-w-[560px] my-24 lg:my-128 px-20 pt-128 z-20"
    >
      <h1>{{ $t("imprint.title") }}</h1>

      <div>
        <h3>
          {{ $t("imprint.maintainer.title") }}
        </h3>

        <div v-for="(info, i) in $tm('imprint.maintainer.info')" :key="i">
          {{ info }}
        </div>

        <div>
          {{ $t("contact.phone.label") }}:
          <a :href="$t('contact.phone.url')" class="underline">{{
            $t("contact.phone.value")
          }}</a>
        </div>
        <div>
          {{ $t("contact.email.label") }}:
          <a :href="$t('contact.email.url')" class="underline">{{
            $t("contact.email.value")
          }}</a>
        </div>
      </div>

      <div
        v-for="(section, i) in $tm('imprint.sections')"
        :key="i"
        class="my-32"
      >
        <h3 v-html="section.title"></h3>

        <div
          v-for="(subsection, j) in section.subsections"
          :key="j"
          class="mb-16"
        >
          <h4 v-if="subsection.subtitle">
            {{ subsection.subtitle }}
          </h4>
          <div v-for="(text, k) in subsection.content" :key="k">{{ text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
